import React, { useEffect, useState } from 'react'
import { Upload, message } from 'antd'
import { getToken } from '../../../../utils/token'

type Props = {
  ticketId: number
  primaryEmail: string
  type: string
  attachments: number[]
  setAttachments: (attachments: number[]) => void
}

const Attachments: React.FC<Props> = ({
  ticketId,
  primaryEmail,
  type,
  attachments,
  setAttachments,
}) => {
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    if (!attachments.length && fileList) {
      setFileList([])
    }
  }, [attachments])

  const props = {
    name: 'file',
    data: {
      ticketId: ticketId,
      primaryEmail: primaryEmail ? true : '',
      public: type == 'public' ? true : '',
    },
    headers: {
      'X-AUTH-TOKEN': getToken(),
    },
    action:
      'https://' +
      process.env.AGENT_DOMAIN +
      '/api/phone/tickets/attachment/upload',
    multiple: true,
    // fileList: fileList,

    onChange(info) {
      let files: any = [...info.fileList]

      setFileList(files)

      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(
          info.file.name +
            ' ' +
            intl.formatMessage({ id: 'ticket / attachment / success' })
        )
        setAttachments([...attachments, info.file.response.id])
      } else if (info.file.status === 'error') {
        message.error(
          info.file.name +
            ' ' +
            intl.formatMessage({ id: 'ticket / attachment / error' })
        )
      }
    },

    onRemove(file) {
      console.log(file.response.id)
      const newAttachments = attachments.filter(
        item => item != file.response.id
      )
      setAttachments(newAttachments)
    },
  }

  return (
    <Upload
      {...props}
      fileList={fileList}
      className="ticket-show-editor__upload"
    >
      <button className="addAttachment button is-default ticket-show-editor__button">
        <span className="far fa-paperclip  ticket-show-editor__icon--size"></span>
      </button>
    </Upload>
  )
}

export default Attachments
